import CoverageMap from './coverage-map'
import CoverageReport from './coverage-report'
import CoverageSectors from './coverage-sectors'
import CoverageShiftForm from './coverage-shift-form'

export default {
  strict: false,
  namespaced: true,
  state: Object.assign(
    CoverageMap.state,
    CoverageReport.state,
    CoverageSectors.state,
    CoverageShiftForm.state
  ),
  mutations: Object.assign(
    CoverageMap.mutations,
    CoverageReport.mutations,
    CoverageSectors.mutations,
    CoverageShiftForm.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/coverage/index.js